var React = require('react');

function Winners (props) {
    return React.createElement("svg",props,React.createElement("g",{"fill":"none","stroke":"#000","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"4"},[React.createElement("circle",{"cx":"63.01","cy":"52.17","r":"16","key":0}),React.createElement("circle",{"cx":"63.01","cy":"52.17","r":"28","key":1}),React.createElement("path",{"d":"m41.92 70.58-18.08 29.75 19.83-6.33 13.67 13.5 5.67-27.33","key":2}),React.createElement("path",{"d":"m84.09 70.58 18.08 29.75-19.83-6.33-13.67 13.5-5.66-27.33","key":3})]));
}

Winners.defaultProps = {"viewBox":"0 0 128 128"};

module.exports = Winners;

Winners.default = Winners;
